import { all, call, put, takeLatest } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import { ForexAPI } from 'client/api.config';
import { serializeToken } from 'client/utils/token';

import { getStatusCode } from 'client/ErrorHandler';
import authActions from './actions';

import { AuthResponse, AuthTypes } from './types';

const { request, failure, success } = authActions;

export function* login({
  payload,
}: ReturnType<typeof request>): Generator<any, void, any> {
  const { email, password } = payload;
  try {
    const response: AxiosResponse<AuthResponse> = yield call(
      ForexAPI.post,
      '/v1/auth/token',
      {
        client_id: process.env.REACT_APP_CLIENT_ID,
        audience: process.env.REACT_APP_FOREX_URL,
        grant_type: 'password',
        username: email,
        password,
      }
    );

    yield ForexAPI.interceptors.request.use((config) => {
      // eslint-disable-next-line no-param-reassign
      config.headers.Authorization = `Bearer ${response.data.access_token}`;
      return config;
    });

    yield put(success(response.data));
    serializeToken(response.data);
  } catch (error) {
    const statusCode = getStatusCode(error);
    yield put(failure(statusCode));
  }
}

export default function* (): Generator<any, void, any> {
  return yield all([takeLatest(AuthTypes.AuthRequest, login)]);
}
